export default __webpack_public_path__ + "static/media/hero-level-2-bg.7b5c5d0e.webp";